// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"b7efb473","496":"dbfe90e8","608":"5a1e84cb"}[chunkId] + ".chunk.js";
};